module.exports = __webpack_public_path__ + "img/38.728a6cb8.png";